import { render } from "./PwaInstallButton.vue?vue&type=template&id=91ebe9fa&scoped=true"
import script from "./PwaInstallButton.vue?vue&type=script&lang=js"
export * from "./PwaInstallButton.vue?vue&type=script&lang=js"

import "./PwaInstallButton.vue?vue&type=style&index=0&id=91ebe9fa&scoped=true&lang=css"

import exportComponent from "/webserver/websites/dev/intrapaf-v2-public-client-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91ebe9fa"]])

export default __exports__